import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { MeetingService } from 'src/app/core/services/meeting.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';

declare var _: any;

@Component({
  selector: 'app-add-participant-modal',
  templateUrl: './add-participant-modal.component.html'
})
export class AddParticipantModalComponent implements OnInit {

  public onClose: Subject<any>;
  resolve: any;

  scheduleId: any;
  jobMatchId: any;
  jobMatchObject: any;
  scheduleObject: any;
  scheduleType: any;
  waitingParticipants: any;
  joiningParticipant: any;
  externalMeetingCallId: any;
  feedbackDetails: any;
  actionType: any;
  primaryHostChangeDetails: any;
  title: string;
  usersToEditFeedback: any;
  readOnly: boolean;
  loadingUsers: boolean;
  enableEditForAttendeeId: any;
  previouslyEnabledEditForAttendeeId: any;
  enabledEditForUser: any;
  previousEnableEditFor: any;
  displayNoSelectionMessage: boolean;
  callbackObject: any;
  participant: any;

  constructor(
    private bsModalRef: BsModalRef,
    private bsModalService: BsModalService,
    private meetingService: MeetingService,
    private modalService: AngularModalService,
    private alertsAndNotificationsService: AlertAndNotificationsService) {
    this.onClose = new Subject();
    this.resolve = this.bsModalService.config.initialState || {};
  }

  ngOnInit() {
    this.scheduleId = this.resolve.scheduleId;
    this.jobMatchId = this.resolve.jobMatchId;
    this.jobMatchObject = this.resolve.jobMatchObject;
    this.scheduleObject = this.resolve.scheduleObject;
    this.scheduleType = this.resolve.scheduleType;
    this.waitingParticipants = this.resolve.waitingParticipants;
    this.joiningParticipant = this.resolve.joiningParticipant;
    this.externalMeetingCallId = this.resolve.externalMeetingCallId;
    this.feedbackDetails = this.resolve.feedbackDetails;
    this.actionType = this.resolve.actionType;
    this.primaryHostChangeDetails = this.resolve.primaryHostChangeDetails;
    if (this.actionType === 'inviteUsers') {
      this.title = 'Invite Users';
    } else if (this.actionType === 'waitingParticipants') {
      this.title = 'Participants Waiting';
      for (const participant of this.waitingParticipants) {
        participant.isApproved = true;
      }
      if (this.waitingParticipants.length === 1) {
        this.joiningParticipant = this.waitingParticipants[0];
        this.actionType = 'joiningParticipant';
      }
    } else if (this.actionType === 'joiningParticipant') {
      this.title = 'Approval to join meeting';
      this.joiningParticipant.isApproved = true;
    } else if (this.actionType === 'enableFeedbackEdit') {
      this.title = 'Leave meeting';
      this.usersToEditFeedback = this.feedbackDetails.usersToEditFeedback;
      this.externalMeetingCallId = this.feedbackDetails.externalMeetingCallId;
      this.scheduleId = this.feedbackDetails.scheduleId;
      this.readOnly = false;
      this.loadingUsers = true;
      this.setFeedbackEnabledAttendeeId();
    } else if (this.actionType === 'primaryHostChange') {
      this.title = 'Assign Primary Host';
      this.usersToEditFeedback = this.primaryHostChangeDetails.usersToEditFeedback;
      this.externalMeetingCallId = this.primaryHostChangeDetails.externalMeetingCallId;
      this.scheduleId = this.primaryHostChangeDetails.meetingScheduleId;
      this.readOnly = false;
      this.loadingUsers = true;
      this.setPrimaryHostAttendeeId();
    }
    this.callbackObject = { callbackType: 'cancel', entity: {} };
  }

  setFeedbackEnabledAttendeeId() {
    this.loadingUsers = true;
    this.meetingService.getFeedbackEditEnabledAttendeeId(this.externalMeetingCallId, (data) => {
      this.enableEditForAttendeeId = data.attendeeId;
      this.previouslyEnabledEditForAttendeeId = data.attendeeId;
      this._setHosts();
    }, error => {
      // do nothing
    });
  }

  setPrimaryHostAttendeeId() {
    this.loadingUsers = true;
    this.meetingService.getPrimaryHostAttendeeId(this.externalMeetingCallId, data => {
      this.enableEditForAttendeeId = data.attendeeId;
      this.previouslyEnabledEditForAttendeeId = data.attendeeId;
      this._setHosts();
    }, error => {
      // do nothing
    });
  }

  _setHosts() {
    this.loadingUsers = true;
    if (this.usersToEditFeedback && this.usersToEditFeedback.length > 0) {
      this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId === this.enableEditForAttendeeId);
      if (this.enabledEditForUser !== undefined) {
        this.readOnly = this.enabledEditForUser.displayName !== 'You';
        this.previousEnableEditFor = _.cloneDeep(this.enabledEditForUser);
      }
    }
    setTimeout(() => {
      this.loadingUsers = false;
    }, 2000);
  }

  onUserWhoCanEditFeedbackChange() {
    this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId === this.enableEditForAttendeeId);
  }

  onPrimaryHostChange() {
    this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId === this.enableEditForAttendeeId);
  }

  confirmWhoCanEditFeedbackChangeAndLeave() {
    const message = `Only '${this.enabledEditForUser.displayName}' will be allowed to edit the feedback.<br> Do you want to continue?`;
    this.alertsAndNotificationsService.showConfirm('Confirm', message, 'warning', true, () => {
      this._approveUserToEditFeedback(true);
    }, () => {
      this._selectPreviousUser();
    });
  }

  confirmPrimaryHostChangeAndLeave() {
    const message = `'${this.enabledEditForUser.displayName}' will be made the primary host.<br> Do you want to continue?`;
    this.alertsAndNotificationsService.showConfirm('Confirm', message, 'warning', true, () => {
      this._approverUserAsPrimaryHost();
    }, () => {
      this._selectPreviousUser();
    });
  }

  _selectPreviousUser() {
    this.loadingUsers = true;
    this.enabledEditForUser = _.cloneDeep(this.previousEnableEditFor);
    if (this.previousEnableEditFor !== null) {
      this.enableEditForAttendeeId = this.previousEnableEditFor.attendeeId;
    } else {
      this.enableEditForAttendeeId = this.previouslyEnabledEditForAttendeeId;
      this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId === this.enableEditForAttendeeId);
    }
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      this.loadingUsers = false;
    }, 1000);
  }

  _approveUserToEditFeedback(isApproved, requesterAttendeeId?) {
    this.loadingUsers = true;
    const currentUserAttendeeId = this.usersToEditFeedback.find(user => user.displayName === 'You').attendeeId;
    const enableEditForAttendeeId = isApproved ? this.enableEditForAttendeeId : requesterAttendeeId;
    const attendeeIds = this.usersToEditFeedback.map(attendee => attendee.attendeeId);
    const approvalDetails = {
      attendeeId: enableEditForAttendeeId,
      approverId: currentUserAttendeeId,
      meetingScheduleId: this.scheduleId,
      externalMeetingCallId: this.externalMeetingCallId,
      attendeeIds,
      approved: isApproved
    };
    this.meetingService.giveFeedbackEditApproval(approvalDetails, (data) => {
      if (isApproved) {
        this.previousEnableEditFor = _.cloneDeep(this.enabledEditForUser);
      }
      setTimeout(() => {
        this.leaveMeeting();
      }, 2000);
    }, error => {
      this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
    });
  }

  _approverUserAsPrimaryHost() {
    this.loadingUsers = true;
    const currentUserAttendeeId = this.usersToEditFeedback.find(user => user.displayName === 'You').attendeeId;
    this.primaryHostChangeDetails.newHostAttendeeId = this.enableEditForAttendeeId;
    this.meetingService.makeUserPrimaryHost(this.primaryHostChangeDetails, (data) => {
      setTimeout(() => {
        this.leaveMeeting();
      }, 2000);
    }, error => {
      this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
    });
  }

  private _close(callbackObject: any): void {
    this.onClose.next(callbackObject);
    this.bsModalRef.hide();
  }

  leaveMeeting() {
    this.callbackObject.callbackType = 'leaveMeeting';
    this._close(this.callbackObject);
  }

  closeModal() {
    this._close(this.callbackObject);
  }

  dismissModal() {
    this._close(null);
  }

  addParticipant() {
    this.callbackObject.callbackType = 'add';
    this.callbackObject.entity = _.cloneDeep(this.participant);
    this._close(this.callbackObject);
  }

  allow() {
    const selectedParticipants = this.waitingParticipants.filter(participant => participant.isApproved);
    if (selectedParticipants.length === 0) {
      this.displayNoSelectionMessage = true;
    } else {
      const entity = {
        participantDetails: this.waitingParticipants,
        externalMeetingCallId: this.externalMeetingCallId
      };
      this.callbackObject.callbackType = 'addParticipants';
      this.callbackObject.entity = _.cloneDeep(entity);
      this._close(this.callbackObject);
    }
  }

  validateParticipant() {
    this.displayNoSelectionMessage = this.waitingParticipants.filter(participant => participant.isApproved).length === 0;
  }

  allowJoiningParticipant() {
    const entity = {
      participantDetails: [this.joiningParticipant],
      externalMeetingCallId: this.externalMeetingCallId
    };
    this.callbackObject.callbackType = 'addParticipants';
    this.callbackObject.entity = _.cloneDeep(entity);
    this._close(this.callbackObject);
  }

  disApproveParticipants() {
    if (this.actionType === 'waitingParticipants') {
      for (const participant of this.waitingParticipants) {
        participant.isApproved = false;
      }
      const entity = {
        participantDetails: this.waitingParticipants,
        externalMeetingCallId: this.externalMeetingCallId
      };
      this.callbackObject.entity = _.cloneDeep(entity);
    } else if (this.actionType === 'joiningParticipant') {
      this.joiningParticipant.isApproved = false;
      const entity = {
        participantDetails: [this.joiningParticipant],
        externalMeetingCallId: this.externalMeetingCallId
      };
      this.callbackObject.entity = _.cloneDeep(entity);
    }
    this.callbackObject.callbackType = 'disApproveParticipants';
    this._close(this.callbackObject);
  }
}
